// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popover_wrapper-module__container--1Bi97{background:white;display:block;-webkit-box-shadow:0 1px 6px 0 rgba(0,0,0,0.2),0 0 0 1px rgba(0,0,0,0.08);-moz-box-shadow:0 1px 6px 0 rgba(0,0,0,0.2),0 0 0 1px rgba(0,0,0,0.08);box-shadow:0 1px 6px 0 rgba(0,0,0,0.2),0 0 0 1px rgba(0,0,0,0.08);-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;overflow:hidden;width:480px}\n", ""]);
// Exports
exports.locals = {
	"container": "popover_wrapper-module__container--1Bi97"
};
module.exports = exports;
